import Glide, {
  Breakpoints,
  Controls,
} from "@glidejs/glide/dist/glide.modular.esm";

const glideContainer = document.querySelector(".glide");

function slider() {
  const glide = new Glide(".glide", {
    animationDuration: 750,
    animationTimingFunc: "ease-in-out",
    type: "slider",
    startAt: 0,
    perView: 2,
    // focusAt: "center",
    breakpoints: {
      600: {
        perView: 1,
      },
    },
  });

  glide.mount({ Breakpoints, Controls });
}

glideContainer && slider();

/**
 *
 * CHANGEMENT DE HASH
 *
 */
const filters = document.querySelectorAll(".js-filter");
let hashFilters = [];
const $containerSelected = document.querySelector("#selected-tags");
const $containerAll = document.querySelector("#all-tags");

function onHashChange() {
  const matches = location.hash.match(/filter=([^&]+)/i);
  const hashFilter = matches ? decodeURIComponent(matches[1]) : "";
  const filtersHashed = hashFilter.split(",");
  const $targets = document.querySelectorAll(".reve-item");

  $targets.forEach(($target) => {
    $target.classList.remove("hide", "show");
  });

  filtersHashed &&
    filtersHashed.forEach((filterHashed) => {
      if (filterHashed != "") {
        const $triggers = document.querySelectorAll(
          ".js-filter" + filterHashed
        );

        const triggerClass = filterHashed.replace(".", "");

        if (hashFilters.indexOf(filterHashed) == -1) {
          hashFilters.push(filterHashed);
        }

        $triggers.forEach(($trigger) => {
          if ($trigger.classList.contains("tag-cloud-link")) {
            $containerSelected.appendChild($trigger);
          }
          $trigger.classList.add("is-checked");
        });

        $targets.forEach(($target) => {
          const $selectedTrigger = $target.querySelector(".is-selected");
          $selectedTrigger && $selectedTrigger.click();
          if (!$target.classList.contains("show")) {
            $target.classList.add("hide");
            if ($target.classList.contains(triggerClass)) {
              $target.classList.remove("hide");
              $target.classList.add("show");
            }
          }
        });
      } else {
        const checkedButtons = document.querySelectorAll(
          ".js-filter.is-checked"
        );

        checkedButtons.forEach((checkedButton) => {
          checkedButton.classList.remove("is-checked");
        });
      }
    });
}

/**
 *
 * CLICK SUR RESET
 *
 */

const $reset = document.querySelector(".section-filtres-reset");

$reset &&
  $reset.addEventListener("click", () => {
    const checkedButtons = document.querySelectorAll(".js-filter.is-checked");

    checkedButtons.forEach((checkedButton) => {
      checkedButton.classList.remove("is-checked");
      if (checkedButton.classList.contains("tag-cloud-link")) {
        $containerAll.appendChild(checkedButton);
      }
    });

    hashFilters = [];

    location.hash = "filter=";

    /**
     *
     * TODO Afficher tous les rêves
     *
     */
  });

/**
 *
 *
 * RECHERCHE DE TAG
 *
 */

const $search = document.querySelector("#search-tag");
const $info = document.querySelector("#search-infos");

$search &&
  $search.addEventListener("input", (e) => {
    const filter = e.target.value.toLowerCase();

    if (filter.length < 3) {
      $info.textContent = "...";
      return;
    }

    const $filter = document.querySelector("." + filter);

    if (!$filter) {
      if (filter.includes(" ")) {
        $info.textContent = "aucun rêve trouvé pour '" + filter + "'";
        // e.target.value = "";
        return;
      }
      $info.textContent = "mot non reconnu...";
      return;
    }
    if ($filter.classList.contains("is-checked")) {
      $info.textContent = "déjà dans la liste";
      return;
    }

    $filter.click();
    e.target.value = "";
    $info.textContent = "...";
  });

/**
 *
 * SUPPRIMER TAG SELECTIONNE
 *
 */
// const $selectedTags = $containerSelected.querySelectorAll(".tag-cloud-link");
// $selectedTags &&
//   $selectedTags.forEach((tag) => {
//     tag.addEventListener("click", () => {
//       console.log("click");
//     });
//   });

$containerSelected &&
  $containerSelected.addEventListener("click", (e) => {
    if (e.target.classList.contains("tag-cloud-link")) {
      $containerAll.appendChild(e.target);
    }
  });

/**
 *
 * CLICK SUR UN FILTRE
 *
 */

// $containerAll = document.querySelector("#all-tags");

filters &&
  filters.forEach((filter) => {
    filter.addEventListener("click", (e) => {
      const hashFilter = filter.dataset.filter;
      if (filter.classList.contains("tag-cloud-link")) {
        $containerSelected.appendChild(filter);
      }

      filter.classList.toggle("is-checked");

      if (filter.classList.contains("is-checked")) {
        if (hashFilters.indexOf(hashFilter) == -1) {
          hashFilters.push(hashFilter);
        }
      } else {
        const index = hashFilters.indexOf(hashFilter);
        if (index != -1) {
          hashFilters.splice(index, 1);
        }
      }

      location.hash = "filter=" + encodeURIComponent(hashFilters.join(","));

      e.preventDefault();
    });
  });

window.addEventListener("hashchange", onHashChange);

onHashChange();
